import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // Check for error from backend redirect
    const params = new URLSearchParams(window.location.search);
    const error = params.get('error');
    if (error) {
      navigate(`/login?error=${error}`);
      return;
    }

    // Extract session token from URL hash (cross-domain flow)
    const hashParams = new URLSearchParams(window.location.hash.replace('#', ''));
    const sessionToken = hashParams.get('session_token');

    if (sessionToken) {
      // Store token for cross-domain API calls
      localStorage.setItem('session_token', sessionToken);
      // Clear the hash so the token isn't visible in the URL
      window.history.replaceState(null, '', window.location.pathname);
    }

    // Fetch the user with the token
    (async () => {
      try {
        const headers = {};
        const token = sessionToken || localStorage.getItem('session_token');
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }
        const res = await axios.get(`${API}/auth/me`, {
          withCredentials: true,
          headers,
        });
        setUser(res.data);

        if (!res.data.onboarded) {
          navigate('/onboarding', { state: { user: res.data } });
        } else {
          navigate(res.data.role === 'startup' ? '/dashboard/startup' : '/my-tshirt');
        }
      } catch (err) {
        console.error('Auth callback failed:', err);
        navigate('/login?error=auth_failed');
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#F6F1E8' }}>
      <div className="bg-[#EDE3C7] border-[3px] border-[#121212] shadow-[6px_6px_0px_0px_#121212] rounded-2xl p-8 text-center">
        <div className="animate-spin w-8 h-8 border-4 border-[#121212] border-t-transparent rounded-full mx-auto mb-4" />
        <p className="font-bold text-lg" style={{ fontFamily: 'Outfit, sans-serif' }}>Logging you in...</p>
      </div>
    </div>
  );
}
